import {ActionTypes} from '../../actions';
import createReducer from '../../../common/util/createReducer';

const INITIAL_STATE = {
  'dealers': [],
  'dealerSelected': null,
  'loading': false,
};

export const wtsDealer = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_WTS_DEALER]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WTS_DEALER]: (state, action) => ({
      ...state,
      'loading': false,
      'dealers': action.response.data,
    }),
    [ActionTypes.FETCHED_WTS_DEALER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'dealers': [],
    }),
    [ActionTypes.CHANGE_WTS_SKILL_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'skillSelected': action.payload,
    }),
    [ActionTypes.CHANGE_WTS_DEALER_SELECTED]: (state, action) => ({
      ...state,
      'loading': false,
      'dealerSelected': action.payload,
    }),
  })(state, action);
};
